module.exports = __webpack_public_path__ + "static/authorize_app-f11c314a044c9a528ecbac9f80cb439f.png";